"use strict";

exports.__esModule = true;
exports.average = exports.sum = exports.normalize = exports.head = exports.tail = void 0;

var tail = function tail(arr) {
  return arr[arr.length - 1];
};

exports.tail = tail;

var head = function head(arr) {
  return arr[0];
};

exports.head = head;

var normalize = function normalize(max, curr) {
  return max - curr / 100 * max;
};

exports.normalize = normalize;

var sum = function sum(a, b) {
  return a + b;
};

exports.sum = sum;

var average = function average(arr) {
  return arr.reduce(sum, 0) / arr.length;
};

exports.average = average;